import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { initialPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const OPERATING_EXPENSES_NAMES = {
  R_AND_D: 'rAndD',
  SALES_AND_MARKETING: 'salesAndMarketing',
  GENERAL_AND_ADMINISTRATIVE: 'generalAndAdministrative',
  OTHER_OPERATING_EXPENSES: 'otherOperatingExpenses',
  TOTAL_OPERATING_EXPENSES: 'totalOperatingExpenses',
} as const;

export const useGetOperatingExpensesTableHeadings = (isExamplePage: boolean) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const operatingExpensesLinkedFields = [
      isExamplePage ? 'Research and Development (R&D)' : t('financialPlan.plannedExpenses.monthlyExpenses.rAndD'),
      isExamplePage ? 'Sales and marketing' : t('financialPlan.plannedExpenses.monthlyExpenses.salesAndMarketing'),
      isExamplePage
        ? 'General and administrative'
        : t('financialPlan.plannedExpenses.monthlyExpenses.generalAndAdministrative'),
      isExamplePage
        ? 'Other operating expenses'
        : t('financialPlan.plannedExpenses.monthlyExpenses.otherOperatingExpenses'),
    ];

    const totalRowTitle = t('financialPlan.profitAndLossProjection.operatingExpenses.totalOperatingExpenses');

    return { operatingExpensesLinkedFields, totalRowTitle };
  }, [t, i18n, isExamplePage]);
};

export const operatingExpensesNameArray = Object.values(OPERATING_EXPENSES_NAMES);

export const operatingExpensesInitialValues = {
  [OPERATING_EXPENSES_NAMES.R_AND_D]: initialPeriodsTableRow,
  [OPERATING_EXPENSES_NAMES.SALES_AND_MARKETING]: initialPeriodsTableRow,
  [OPERATING_EXPENSES_NAMES.GENERAL_AND_ADMINISTRATIVE]: initialPeriodsTableRow,
  [OPERATING_EXPENSES_NAMES.OTHER_OPERATING_EXPENSES]: initialPeriodsTableRow,
  [OPERATING_EXPENSES_NAMES.TOTAL_OPERATING_EXPENSES]: initialPeriodsTableRow,
};
